var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNetlify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 260,
    viewBox: "0 0 261 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_20_1674)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.724,
    y: 36,
    width: 180,
    height: 180,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.224,
    y: 36.5,
    width: 179,
    height: 179,
    rx: 31.5,
    stroke: "#D9D9D9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.354 140.717L115.829 135.592C115.727 135.791 115.612 135.983 115.487 136.169L137.814 168.738L139.161 167.392L142.959 143.772C142.317 143.5 141.747 143.083 141.295 142.553C140.843 142.022 140.521 141.394 140.354 140.717V140.717ZM131.408 108.658C130.489 110.067 128.903 111 127.097 111C126.819 111 126.548 110.972 126.283 110.93L115.098 128.43L144.98 115.57C144.97 115.45 144.944 115.338 144.944 115.214C144.944 114.963 144.978 114.719 145.019 114.478L131.408 108.658V108.658ZM132.22 105.469L146.698 111.659C147.16 111.299 147.688 111.032 148.252 110.875L150.631 96.0782L141.565 87.0123L131.361 102.98C131.861 103.72 132.157 104.578 132.22 105.469V105.469ZM162.558 108.005L153.472 98.9172L151.497 111.186C151.998 111.438 152.447 111.78 152.823 112.195L162.558 108.005ZM140.789 137.486C141.144 136.84 141.655 136.294 142.275 135.895C142.895 135.496 143.604 135.259 144.339 135.203L146.948 118.974C146.744 118.838 146.561 118.675 146.381 118.508L116.328 131.442C116.404 131.756 116.458 132.076 116.483 132.409L140.789 137.486ZM165.033 110.481L154.52 115.004L180.458 126.094L180.551 126L165.033 110.481ZM146.247 143.82L143.088 163.462L161.433 145.117L148.219 142.358C147.712 143.021 147.029 143.528 146.247 143.82ZM110.589 138.771C109.925 138.771 109.289 138.656 108.694 138.454L102.6 147.991L100.245 145.638L106.017 136.606C105.874 136.429 105.741 136.245 105.619 136.053L95.1626 140.555L92.6841 138.076L104.129 133.15L83.4378 128.831L80.6077 126L81.503 125.105L105.364 130.086C105.638 129.565 105.99 129.089 106.406 128.673L94.8251 111.781L97.1641 109.442L109.264 127.092C109.698 126.991 110.142 126.939 110.589 126.937C111.099 126.937 111.595 127.009 112.068 127.131L123.39 109.415C122.468 108.459 121.954 107.183 121.954 105.855C121.954 105.448 122.006 105.055 122.095 104.677L107.97 98.6375L110.448 96.1595L123.83 101.883C124.509 101.323 125.32 100.948 126.186 100.793C127.051 100.638 127.942 100.708 128.773 100.997L139.212 84.6592L130.553 76L80.553 126L130.553 176L135.473 171.08L112.979 138.264C112.227 138.598 111.412 138.77 110.589 138.771ZM150.131 119.673L147.477 136.172C147.941 136.545 148.325 137.007 148.606 137.531C148.888 138.055 149.061 138.631 149.116 139.224L164.183 142.369L177.979 128.572L153.077 117.925C152.364 118.874 151.305 119.502 150.131 119.674V119.673Z",
    fill: "#25C7B7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_20_1674",
    x: 0.723999,
    y: 0,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_20_1674"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_20_1674",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetlify);
export default __webpack_public_path__ + "static/media/netlify.453883c86cd8a71c371f5ec9801d8c15.svg";
export { ForwardRef as ReactComponent };